module.exports = __webpack_public_path__ + "static/media/asset-icon.226b7956.svg";